import React from 'react';

import { Toaster } from '@easydatasolution/ui-react/components/ui/sonner';
import { LazyMotion, domAnimation } from 'motion/react';

export const RootProvider = ({ element }: { element: React.ReactNode }) => (
	<>
		<LazyMotion features={domAnimation}>{element}</LazyMotion>
		<Toaster richColors />
	</>
);
